import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@pwc/appkit-react/lib/Checkbox';

import { FormikPropTypes } from '../propTypes';
import ErrorMessage from '../select/errorMessage.component';

const CheckboxFormik = ({
  className = '',
  name,
  value,
  disabled = false,
  label = '',
  formik,
  valueFormatter,
  handleExternalChange = false,
  hidden = false,
  ...restProps
}) => {
  const booleanValue = typeof value === 'string'
    ? value === 'true' || value === 'Y' || value === '1'
    : Boolean(value);

  const handleBlur = useCallback(() => {
    formik.setTouched({
      ...formik.touched,
      [name]: true,
    });
    formik.setFieldValue(name, valueFormatter ? valueFormatter(booleanValue) : booleanValue);
  }, [name, formik, booleanValue, valueFormatter]);

  const handleChange = useCallback(event => {
    formik.setFieldValue(name, event.target.checked);
  }, [name, formik]);

  useEffect(() => {
    if (handleExternalChange) {
      formik.setFieldValue(name, booleanValue);
    }
  }, [name, booleanValue, handleExternalChange]); // eslint-disable-line react-hooks/exhaustive-deps


  return hidden ? null : (
    <div className={`checkbox-wrapper ${className}`}>
      <Checkbox
        name={name}
        value={String(booleanValue) || ''}
        disabled={disabled}
        checked={booleanValue}
        onBlur={handleBlur}
        onChange={handleChange}
        {...restProps}
      >
        {label}
      </Checkbox>
      <div className="invalid-feedback">
        <ErrorMessage name={name} formik={formik} />
      </div>
    </div>
  );
};

CheckboxFormik.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  disabled: PropTypes.bool,
  label: PropTypes.node,
  formik: FormikPropTypes.isRequired,
  valueFormatter: PropTypes.func,
  handleExternalChange: PropTypes.bool,
  hidden: PropTypes.bool,
};

export default CheckboxFormik;
